import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

const GraphContainer = styled.div`
    box-shadow: 0 3px 6px 0 rgb(14 30 62 / 8%);
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    margin-bottom: 24px;
    height: 524px;
`;

export const ContentContainer = styled.div`
    padding: 0 25px 25px 25px;
    height: 100%;
`;

export const LoaderContainer = styled.div`
    height: 366px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
